
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/library/midtermplan",
      function () {
        return require("private-next-pages/ir/library/midtermplan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/library/midtermplan"])
      });
    }
  